module.exports = __webpack_public_path__ + "media/images/number_21-70d38562885ccdc8409e835011bb13b2.png";